import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 px-4 border-t border-cream-300 bg-cream-200/30" data-id="element-1">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-ink-500" data-id="element-2">
          <span data-id="element-3">© {new Date().getFullYear()} El Juego Invisible</span>
          <span className="hidden sm:inline" data-id="element-4">·</span>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-ocean transition-colors underline underline-offset-2" data-id="element-5">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline" data-id="element-6">·</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-ocean transition-colors underline underline-offset-2" data-id="element-7">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-8">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" onClick={() => setActiveModal(null)} data-id="element-9">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-xl border border-cream-300 max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-10">
              <div className="flex items-center justify-between p-6 border-b border-cream-300" data-id="element-11">
                <h2 className="text-xl font-bold text-ocean" data-id="element-12">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-1 rounded-lg hover:bg-cream-200 transition-colors text-ink-500 hover:text-ink-900" data-id="element-13">
                  <XIcon className="w-5 h-5" data-id="element-14" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-ink-700 text-sm leading-relaxed space-y-4" data-id="element-15">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-16" /> : <TermsContent data-id="element-17" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p data-id="element-18">
        <strong className="text-ink-900" data-id="element-19">Última actualización:</strong> Marzo
        2026
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-20">
        1. Información que recopilamos
      </h3>
      <p data-id="element-21">
        Recopilamos información personal que nos proporcionas directamente al
        realizar una compra, como tu nombre, dirección de correo electrónico y
        datos de pago. No almacenamos información de tarjetas de crédito
        directamente; los pagos son procesados por proveedores de pago seguros
        de terceros.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-22">
        2. Uso de la información
      </h3>
      <p data-id="element-23">Utilizamos tu información personal para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-24">
        <li data-id="element-25">Procesar y entregar tu compra digital</li>
        <li data-id="element-26">Enviarte el producto y actualizaciones relacionadas</li>
        <li data-id="element-27">Responder a tus consultas o solicitudes de soporte</li>
      </ul>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-28">
        3. Protección de datos
      </h3>
      <p data-id="element-29">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-30">
        4. Compartir información
      </h3>
      <p data-id="element-31">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de confianza que nos ayudan
        a operar nuestro sitio web y procesar pagos, siempre que dichas partes
        acuerden mantener esta información confidencial.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-32">5. Tus derechos</h3>
      <p data-id="element-33">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, contáctanos a través de
        los canales disponibles en nuestro sitio.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-34">6. Cookies</h3>
      <p data-id="element-35">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Puedes configurar tu navegador para rechazar cookies, aunque
        esto puede afectar la funcionalidad del sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p data-id="element-36">
        <strong className="text-ink-900" data-id="element-37">Última actualización:</strong> Marzo
        2026
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-38">
        1. Aceptación de los términos
      </h3>
      <p data-id="element-39">
        Al acceder y utilizar este sitio web y al adquirir "El Juego Invisible",
        aceptas estar sujeto a estos términos y condiciones. Si no estás de
        acuerdo con alguna parte de estos términos, no debes utilizar este
        sitio.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-40">2. Producto digital</h3>
      <p data-id="element-41">
        "El Juego Invisible" es un producto digital en formato PDF. Una vez
        completada la compra, recibirás acceso inmediato al contenido. Debido a
        la naturaleza digital del producto, no se aceptan devoluciones una vez
        descargado el material.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-42">
        3. Propiedad intelectual
      </h3>
      <p data-id="element-43">
        Todo el contenido de "El Juego Invisible", incluyendo texto, gráficos,
        diseño y estructura, está protegido por derechos de autor. Queda
        prohibida la reproducción, distribución o reventa del material sin
        autorización expresa por escrito.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-44">4. Uso permitido</h3>
      <p data-id="element-45">
        La licencia de compra es personal e intransferible. El material está
        destinado exclusivamente para uso personal y familiar. No está permitido
        compartir, redistribuir o utilizar el contenido con fines comerciales.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-46">
        5. Limitación de responsabilidad
      </h3>
      <p data-id="element-47">
        El contenido de "El Juego Invisible" tiene fines educativos e
        informativos. No sustituye el consejo profesional de psicólogos, médicos
        o entrenadores certificados. Los resultados pueden variar según la
        aplicación individual.
      </p>

      <h3 className="text-lg font-bold text-ocean mt-6" data-id="element-48">6. Modificaciones</h3>
      <p data-id="element-49">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio web.
      </p>
    </>;
}